// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import FastClick from "fastclick"; //移动端 300毫秒延迟的处理
import "./config/rem";   //自己配置的rem单位,所以整个项目中单位都是rem,100px=1rem
import "./config/common.css";  //css 公共文件
import Mint from "mint-ui";   //移动端 mint_ui 前端vue 组件库
import "mint-ui/lib/style.css";  //样式说明 
import ElementUI from "element-ui";   //引入element_ui
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";  //axios请求数据
import VueAxios from "vue-axios";
import "./gt"; 
Vue.use(require('vue-wechat-title'))
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
import Qs from "qs";  //qs解决了axios向后台发送数据的默认格式为json。
Vue.prototype.Qs = Qs;
Vue.prototype.$axios = axios;

if ("addEventListener" in document) {   //移动端点击处理
  document.addEventListener(
    "DOMContentLoaded",
    function() {
      FastClick.attach(document.body);
    },
    false
  );
}

// import moment from "moment/moment";   //时间戳处理 ,全局 管道符
// Vue.filter("moments", function(value, formatString) {
//   formatString = formatString || "HH:mm:ss:SSS";
//   return moment(value * 1000).format(formatString);
// });

Vue.config.productionTip = false;

Vue.use(Mint);

Vue.use(ElementUI);
Vue.use(VueAxios, axios);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js